import script from "./NewsManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsManage.vue?vue&type=script&lang=ts&setup=true"

import "./NewsManage.vue?vue&type=style&index=0&id=6b498fe3&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b498fe3"]])

export default __exports__